import { render, staticRenderFns } from "./NewFactCheckCategory.vue?vue&type=template&id=4776a11b"
import script from "./NewFactCheckCategory.vue?vue&type=script&lang=ts"
export * from "./NewFactCheckCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports